export var FontStyleName;
(function (FontStyleName) {
    FontStyleName["STANDART"] = "standart";
    FontStyleName["BOLD"] = "bold";
    FontStyleName["ITALIC"] = "italic";
    FontStyleName["BOLDITALIC"] = "boldItalic";
})(FontStyleName || (FontStyleName = {}));
